import React from 'react';
import queryString from 'query-string';
import { useLocation } from 'react-router-dom';
import { appUrl } from '@dashboard/services/env';

export default function IntegrationsSlackCallback() {
  const { search } = useLocation();

  React.useEffect(() => {
    const { code } = queryString.parse(search);

    window.opener.postMessage(
      {
        type: 'slack-oauth-callback',
        code,
      },
      appUrl,
    );
    window.close();
  }, [search]);

  return null;
}
